import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-picview',
  templateUrl: './picview.component.html',
  styleUrl: './picview.component.scss'
})
export class PicviewComponent {

  @Input() picData: any
  @Output() closePicDialogue = new EventEmitter<any>();
  showclickedPic: boolean = true;
  pics: any[] = [];
  constructor() {

  }
  ngOnInit() {
    this.showclickedPic = true;
    if (Array.isArray(this.picData?.picFile)) {
      this.pics = this.picData?.picFile;
    } else {
      // If only one image, make it an array for consistency
      this.pics = [this.picData?.picFile];
    }
  }

  //for closing dialogue
  closeDialogue() {
    this.closePicDialogue.emit(false)
  }
}
